import React, { useMemo } from 'react';
import classnames from 'classnames';

import Image from 'components/Image';
import { IFateCard } from 'types/fate';

type Props = {
  data: IFateCard,
  onClick: () => void,
};

const FateCard = (props: Props) => {
  const { data, onClick } = props;
  const { description } = data;

  const border = useMemo(() => data.border?.toLowerCase(), [data.border]);

  return (
    <div className="media storylet fate-card">
      <div className="storylet__bordered-container fate-card__bordered-container">
        <div className="storylet__left">
          <div className={classnames('media__object icon icon--fate', !data.canAfford && 'icon--locked')}>
            <Image
              borderContainerClassName="fate-card__border"
              className="media__object fate-card__image"
              icon={data.image}
              alt={data.name}
              type="icon"
              border={border}
            />
          </div>
        </div>
        <div className="media__body fate-card__body">
          <h3 className="heading heading--3">{data.name}</h3>
          <p dangerouslySetInnerHTML={{ __html: description }} />
          <p>
            You need
            {' '}
            {data.price}
            {' '}
            Fate for this.
          </p>
          <div className="buttons">
            <button
              className={classnames('button button--primary', !data.canAfford && 'button--disabled')}
              disabled={!data.canAfford}
              onClick={onClick}
              type="button"
            >
              {data.price}
              {' '}
              Fate
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FateCard;
